import * as React from 'react'
import './Signupform.css';
import './ContactForm.css';
import { Icon } from '../Icons/Icon';
import { GROW_BASIC_PLAN, GROW_PREMIUM_PLAN } from '../Types/ClientOfferTypes';
// import { Card } from './Card';

interface SignupFormData {
  username: string;
  email: string;
  password: string;
  confirmPassword: string;
  membershipOption:MembershipOption | undefined;
}

interface MembershipOption {
  id: string;
  duration: string;
  price: number;
  originalPrice?: number;
  features: string[];
  popular?: boolean;
}
export const Signupform = () => {
 const [selectedMembership, setSelectedMembership] = React.useState<MembershipOption | null>(null);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [step, setStep] = React.useState<'membership' | 'signup' | 'payment'>('membership');
  const [form,setForm] = React.useState<SignupFormData>({  
      username: '',
      email: '',
      password: '',
      confirmPassword: '',
      membershipOption:undefined
    }
  );
  
/*MEMBERSHIP OPTIONS SKULLE KUNNA VARA NÅGOT SOM HÄMTAS SÅ ATT DET GÅR ATT ADMINISTRERA VIA ADMIN PORTALEN
  DOCK SÅ BEHÖVER JAG VERSIONS HANTERA I SÅ FALL, 
  SÅ att det pris osv som man väljer inte påverkas i efterhand av en ändring i membershiptyperna
*/
  const membershipOptions: MembershipOption[] = [
    {
      id: GROW_BASIC_PLAN.key,
      duration: GROW_BASIC_PLAN.label,
      price: GROW_BASIC_PLAN.pricePerMonth,
      features: [
        'Månadsvis material i hälsoportalen',
        'Självständigt arbete varje månad',
        'Ingen inkluderad samtalstid'
      ]
    },
    {
      id: GROW_PREMIUM_PLAN.key,
      duration: GROW_PREMIUM_PLAN.label,
      price: GROW_PREMIUM_PLAN.pricePerMonth,
      popular: true,
      features: [
        'Allt material i hälsoportalen',
        'Ett inkluderat samtal per månad',
        'Stöd för kontinuitet och fördjupning'
      ]
    }
  ];

  const handleMembershipSelect = (membership: MembershipOption) => {
    setSelectedMembership(membership);
    setStep('signup');
  };

  const handleSignupSubmit = (data: SignupFormData) => {
    if (data.password !== data.confirmPassword) {
      // form.setError('confirmPassword', {
      //   type: 'manual',
      //   message: 'Lösenorden matchar inte'
      // });
      return;
    }

    setStep('payment');
  };

  const handleKlarnaPayment = async () => {
    if (!selectedMembership) return;

    setIsProcessing(true);

    setTimeout(() => {
      setIsProcessing(false);
      alert('Betalning genomförd! Välkommen som medlem.');
    }, 2000);
  };

  const renderMembershipSelection = () => (
    <div >
      
      
        <div className="title" style={{display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center'}}>
            <span>
              <h1 className="heading-xl">Välj ditt medlemskap</h1>
              <p className="text-secondary">Börja din resa mot bättre hälsa och välmående</p>
            </span>
            </div>
        <div style={{display:'flex',justifyContent:'center'}}>
         
          
      {/* <div className="section-header">
        <h1 className="heading-primary">Välj ditt medlemskap</h1>
        <p className="text-secondary">Börja din resa mot bättre hälsa och välmående</p>
      </div> */}

      <div className="membership-grid" style={{
  //       flex: '1',
  // display: 'flex',
  // flexWrap: 'wrap',
  // gap: '1rem',
  // padding: '1rem',
  // overflowY: 'auto'
  }}>
        {membershipOptions.map((option,index) => (
          <div
            key={option.id}
             className="cards"
            style={{}}
            //className={`membership-card ${option.popular ? 'popular' : ''}`}
            onClick={() => handleMembershipSelect(option)}
          >
            {/* {option.popular && (
              <div className="badge-popular">
                Mest populär
              </div>
            )} */}
            <div className="image-container">
          <img src={`images/membership-${index +1}.png`} alt="Medlemskap" className="responsive-img" />
          </div>

            <div className="card__content">
              <div style={{fontWeight:600}}>
               🌿 {option.duration} månaders medlemskap
              </div>
              <div className="price-section">
                <div className="price-current" style={{fontWeight:600,fontSize:'24px'}}>
                  {option.price} kr
                </div>
                {option.originalPrice && (
                  <p className="price-original">
                    Ordinarie pris: {option.originalPrice} kr
                  </p>
                )}
                <p className="price-save">
                  Spara {option.originalPrice ? option.originalPrice - option.price : 0} kr
                </p>
              </div>

            <div>
              <ul className="feature-list">
                {option.features.map((feature, index) => (
                  <li key={index} className="feature-item">
                    {/* <CheckCircle className="feature-icon" /> */}
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            <Icon.KlarnaWhite/>
            </div>
                </div>
          </div>
        ))}
        </div>
        
        </div>
      
    </div>
  );

  const renderSignupForm = () => (
    <div className="form-container">
      <div className="form-header">
        <h1 className="heading-primary">Skapa ditt konto</h1>
        <p className="text-secondary">Registrera dig för att slutföra ditt köp</p>
      </div>

      {selectedMembership && (
        <div className="selected-plan">
          <div className="card-content">
            <div className="plan-details">
              <div>
                <h3 className="plan-title">{selectedMembership.duration}</h3>
                <p className="text-secondary">Valt paket</p>
              </div>
              <div className="plan-price">
                <p className="price-current">{selectedMembership.price} kr</p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div>
        <div className="card-content">
          <form {...form}>
            <form onSubmit={/*form.handleSubmit(handleSignupSubmit)*/()=> console.log()} className="form-fields">
              {/* Form fields here remain unchanged but styled with CSS classes */}

              <div className="button-group">
                <button type="button"  onClick={() => setStep('membership')} className="button-outline">
                  Tillbaka
                </button>
                <button type="submit" className="button-primary">
                  Fortsätt till betalning
                </button>
              </div>
            </form>
          </form>
        </div>
      </div>
    </div>
  );

  const renderPayment = () => (
    <div className="form-container">
      <div className="form-header">
        <h1 className="heading-primary">Slutför ditt köp</h1>
        <p className="text-secondary">Betala säkert med Klarna</p>
      </div>

      {selectedMembership && (
        <div className="selected-plan">
          <div className="card-content">
            <div className="plan-summary">
              <div className="plan-details">
                <span className="plan-title">{selectedMembership.duration}</span>
                <span className="price-current">{selectedMembership.price} kr</span>
              </div>
              <div className="plan-user">
                <span>Konto: {form.email}</span>
              </div>
            </div>
          </div>
        </div>
      )}

      <div>
        <div className="payment-content">
          {/* <CreditCard className="payment-icon" /> */}
          <h3 className="payment-title">Betala med Klarna</h3>
          <p className="text-secondary">Säker betalning med möjlighet att dela upp din betalning</p>

          <div className="button-group">
            <button onClick={handleKlarnaPayment} disabled={isProcessing} className="button-primary">
              {isProcessing ? 'Bearbetar...' : `Betala ${selectedMembership?.price} kr med Klarna`}
            </button>

            <button type="button"  onClick={() => setStep('signup')} className="button-outline" disabled={isProcessing}>
              Tillbaka
            </button>
          </div>

          <p className="terms-text">
            Genom att slutföra köpet godkänner du våra villkor och integritetspolicy
          </p>
        </div>
      </div>
    </div>
  );

  return (
    <div className="page-wrapper">
      <div className="container">
        {step === 'membership' && renderMembershipSelection()}
        {step === 'signup' && renderSignupForm()}
        {step === 'payment' && renderPayment()}
      </div>
    </div>
  );
}
